import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton, MatButtonModule } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatCardModule } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatInput } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { ContactClientCreateComponent } from '../../contact/contact-client-create/contact-client-create.component'
import { MatDividerModule } from '@angular/material/divider'
import { NgxMaskDirective } from 'ngx-mask'
import { ViaCepService } from '../../../core/services/address/via-cep/via-cep.service'
import { EmployeeStatusService } from '../../../core/services/employee/employee-status/employee-status.service'
import { AddressTypeService } from '../../../core/services/address/address-type/address-type.service'
import { EmployeeRoleService } from '../../../core/services/employee/employee-role/employee-role.service'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { emailValidator } from '../../../shared/utils/email_validator'
import moment from 'moment/moment'
import { cpfValidator } from '../../../shared/utils/cpf_validator'
import { CreateDriverModel } from '../../../core/models/driver.model'
import { DriverTypeService } from '../../../core/services/driver/driver-type/driver-type.service'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { DriverUploadCreateComponent } from '../driver-upload-create/driver-upload-create.component'
import { DriverService } from '../../../core/services/driver/driver/driver.service'
import { ModalSupplierComponent } from '../../person/supplier/modal_supplier/modal-supplier.component'

@Component({
  selector: 'driver-create',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatIcon,
    MatInput,
    MatOption,
    MatSelect,
    MatDividerModule,
    ContactClientCreateComponent,
    NgxMaskDirective,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSlideToggle,
    DriverUploadCreateComponent,
    MatButtonModule
  ],
  templateUrl: './driver-create.component.html',
  styleUrl: './driver-create.component.scss',
  providers: [
    ViaCepService,
    EmployeeStatusService,
    DriverService,
    EmployeeRoleService,
    AddressTypeService,
  ],
  standalone: true,
})
export class DriverCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private viaCepService: ViaCepService,
    private employeeStatusService: EmployeeStatusService,
    private driverService: DriverService,
    private addressTypeService: AddressTypeService,
    private driverTypeService: DriverTypeService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<DriverCreateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {
    const today = new Date()
    const currentYear = today.getFullYear()
    const currentMonth = today.getMonth()
    const currentDay = today.getDate()
    this.maxDate = new Date(currentYear - 18, currentMonth, currentDay)
    this.minDate = today
  }

  @Output() responseCreate = new EventEmitter()
  @ViewChild('birth') datepickerBirth: MatDatepicker<any> | undefined
  @ViewChild('hiring') datepickerHiring: MatDatepicker<any> | undefined
  @ViewChild('validity') datepickerValidity: MatDatepicker<any> | undefined

  formEmployee: FormGroup = new FormGroup({})
  maxDate!: Date
  minDate!: Date

  loading = false
  supplierButton = false
  supplierSelected: any = {}
  listAddressType: any[] = []
  listStatusEmployee: any[] = []
  listTypeDriver: any[] = []
  listCategory: any[] = [
    { id: 'A', description: 'A' },
    { id: 'B', description: 'B' },
    { id: 'C', description: 'C' },
    { id: 'D', description: 'D' },
    { id: 'E', description: 'E' },
  ]

  contactList: any[] = []
  fileList: any[] = []
  // public TipoDocId: number = 0
  // public Descricao: string = ''
  // public Arquivo: File | null = null

  enderecosAdicionais: any[] = []
  enderecoAdicionalForm: FormGroup = new FormGroup({})

  ngOnInit(): void {
    this.getAddressType()
    this.getDriverType()
    this.getStatusEmployee()
    this.createForm()
    this.createEnderecoAdicionalForm()
    this.checkSupplier();
  }

  createEnderecoAdicionalForm(): void {
    this.enderecoAdicionalForm = this.formBuilder.group({
      tipoEnderecoId: [''],
      cep: [''],
      logradouro: [''],
      numero: [''],
      complemento: [''],
      bairro: [''],
      cidade: [''],
      estado: [''],
      pais: ['Brasil'],
    })
  }

  adicionarEndereco(): void {
    const v = this.enderecoAdicionalForm.value
    if (!v.cep && !v.logradouro) return
    this.enderecosAdicionais.push({ ...v })
    this.enderecoAdicionalForm.reset({ pais: 'Brasil' })
  }

  removerEndereco(index: number): void {
    this.enderecosAdicionais.splice(index, 1)
  }

  close() {
    this.dialogRef.close()
  }

  getAddressType() {
    this.addressTypeService.listAddressType().subscribe({
      next: (response: any) => {
        const list = []
        for (let index = 0; index < response.data.length; index++) {
          const element = response.data[index]
          list.push({
            id: element.id,
            description: element.descricao,
          })
        }
        this.listAddressType = list
      },
      error: (err: any) => { },
      complete: () => { },
    })
  }

  getDriverType() {
    this.driverTypeService.listDriverType().subscribe({
      next: (response: any) => {
        const list = []
        for (let index = 0; index < response.data.length; index++) {
          const element = response.data[index]
          list.push({
            id: element.id,
            description: element.descricao,
          })
        }
        this.listTypeDriver = list
      },
      error: (err: any) => { },
      complete: () => { },
    })
  }

  checkSupplier() {
    const value = this.formEmployee.get('isEmployee')?.value;
    if (!value) {
      // Funcionário: habilita campo fornecedor
      this.formEmployee.get('supplier')?.enable();
      this.formEmployee.get('isSelfEmployed')?.enable();
      this.supplierButton = true
    } else {
      // Prestador: desabilita campo fornecedor e limpa valor
      this.formEmployee.get('isSelfEmployed')?.setValue(false);
      this.formEmployee.get('isSelfEmployed')?.disable();
      this.formEmployee.get('supplier')?.disable();
      this.formEmployee.get('supplier')?.setValue('');
      this.supplierButton = false
      this.supplierSelected = {};
    }
  }

  checkSelfEmployed() {
    const value = this.formEmployee.get('isSelfEmployed')?.value;
    if (!value) {
      // Funcionário: habilita campo fornecedor
      this.formEmployee.get('supplier')?.enable()
      this.supplierButton = true
    } else {
      // Prestador: desabilita campo fornecedor e limpa valor
      this.formEmployee.get('supplier')?.disable()
      this.supplierButton = false
      this.formEmployee.get('supplier')?.setValue('')
      this.supplierSelected = {};
    }
  }

  getStatusEmployee() {
    this.employeeStatusService.listEmployeeStatus().subscribe({
      next: (response: any) => {
        const list = []
        for (let index = 0; index < response.data.length; index++) {
          const element = response.data[index]
          list.push({
            id: element.id,
            description: element.descricao,
          })
        }
        this.listStatusEmployee = list
      },
      error: (err: any) => { },
      complete: () => { },
    })
  }

  createModel() {
    const model = new CreateDriverModel()

    // MotoristaRegisterObj
    model.Nome = this.formEmployee.get('name')?.value
    model.Cpf = this.formEmployee.get('cpf')?.value
    model.Email = this.formEmployee.get('email')?.value
    model.Matricula = this.formEmployee.get('registration')?.value
    model.DataNascimento =
      this.formEmployee.get('birth')?.value != ''
        ? moment(this.formEmployee.get('birth')?.value).format('DD/MM/YYYY')
        : ''
    model.DataContratacao =
      this.formEmployee.get('hiring')?.value != ''
        ? moment(this.formEmployee.get('hiring')?.value).format('DD/MM/YYYY')
        : ''
    model.StatusId = this.formEmployee.get('statusEmployee')?.value
    model.TipoMotoristaId = this.formEmployee.get('typeDriver')?.value
    model.NumeroRegistro = this.formEmployee.get('docRegistration')?.value
    model.Categoria = this.formEmployee.get('docCategory')?.value
    model.Validade =
      this.formEmployee.get('docValidity')?.value != ''
        ? moment(this.formEmployee.get('docValidity')?.value).format(
          'DD/MM/YYYY',
        )
        : ''

    model.IsFuncionario = this.formEmployee.get('isEmployee')?.value ? 'S' : 'N'
    model.IsAutonomo = this.formEmployee.get('isSelfEmployed')?.value ? 'S' : 'N'
    // model.IsFuncionario = this.formEmployee.get('isEmployee')?.value

    // model.FornecedorId = 0
    model.FornecedorId = this.supplierSelected.id ? this.supplierSelected.id : null
    model.Cnpj = this.supplierSelected.cnpj ? this.supplierSelected.cnpj : ''
    model.InscricaoEstadual = this.supplierSelected.inscricaoEstadual ? this.supplierSelected.inscricaoEstadual : ''
    model.InscricaoMunicipal = this.supplierSelected.inscricaoMunicipal ? this.supplierSelected.inscricaoMunicipal : ''
    model.NomeFantasia = this.supplierSelected.nomeFantasia ? this.supplierSelected.nomeFantasia : ''
    model.RazaoSocial = this.supplierSelected.razaoSocial ? this.supplierSelected.razaoSocial : ''
    model.FornecedorExiste = this.supplierSelected ? 'S' : 'N'

    // MotoristaEnderecoRegisterObj
    model.TipoEnderecoId = this.formEmployee.get('addressType')?.value
    model.Cep = this.formEmployee.get('postalCode')?.value
    model.Logradouro = this.formEmployee.get('street')?.value
    model.Numero = this.formEmployee.get('number')?.value
    model.Complemento = this.formEmployee.get('complement')?.value
    model.Bairro = this.formEmployee.get('neighborhood')?.value
    model.Estado = this.formEmployee.get('state')?.value
    model.Cidade = this.formEmployee.get('city')?.value
    model.Pais = this.formEmployee.get('country')?.value
    model.Latitude = ''
    model.Longitude = ''

    model.EnderecosAdicionais = this.enderecosAdicionais

    if (this.contactList.length > 0) {
      model.Contatos = this.contactList.map(
        ({ tipoContato, idCreate, ...remainder }) => remainder,
      )
    }

    if (this.fileList.length > 0) {
      model.Files = this.fileList.map(({ idCreate, ...remainder }) => remainder)
    }
    return model.toFormData()
  }

  createForm(): void {
    this.formEmployee = this.formBuilder.group({
      // Employee fields
      name: ['', [Validators.required, Validators.minLength(3)]],
      cpf: ['', [Validators.required, cpfValidator()]],
      email: ['', [Validators.required, emailValidator()]],
      registration: [''],
      birth: ['', [Validators.required]],
      hiring: [''],
      statusEmployee: ['', [Validators.required]],
      typeDriver: ['', [Validators.required]],
      docRegistration: ['', [Validators.required]],
      docCategory: ['', [Validators.required]],
      docValidity: ['', Validators.required],
      isEmployee: [true],
      // Adress fields
      addressType: ['', [Validators.required]],
      postalCode: ['', [Validators.required]],
      street: ['', [Validators.required]],
      number: ['', [Validators.required]],
      complement: [''],
      neighborhood: ['', [Validators.required]],
      state: ['', [Validators.required]],
      city: ['', [Validators.required]],
      country: ['', [Validators.required]],
      supplier: [''],
      isSelfEmployed: [false],
    })

  }

  addSupplier() {
    const dialogRef = this.dialog.open(ModalSupplierComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.supplierSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          this.supplierSelected = response.selection
          this.formEmployee
            .get('supplier')!
            .setValue(this.supplierSelected.nomeFantasia)
        } else {
          this.supplierSelected = {}
          this.formEmployee.get('supplier')!.setValue('')
        }
      }
    })
  }

  fillFormViaCep(element: any) {
    if (element.erro) {
      this.formEmployee.get('street')?.setValue('')
      this.formEmployee.get('number')?.setValue('')
      this.formEmployee.get('complement')?.setValue('')
      this.formEmployee.get('neighborhood')?.setValue('')
      this.formEmployee.get('city')?.setValue('')
      this.formEmployee.get('state')?.setValue('')
      this.formEmployee.get('country')?.setValue('')
    } else {
      this.formEmployee.get('street')?.setValue(element.logradouro)
      this.formEmployee.get('number')?.setValue('')
      this.formEmployee.get('complement')?.setValue(element.complemento)
      this.formEmployee.get('neighborhood')?.setValue(element.bairro)
      this.formEmployee.get('city')?.setValue(element.localidade)
      this.formEmployee.get('state')?.setValue(element.estado)
      this.formEmployee.get('country')?.setValue('Brasil')
    }
  }

  getAddressByPostalCode() {
    const postalCode = this.formEmployee.get('postalCode')?.value
    if (postalCode != '' && postalCode.length >= 8) {
      this.viaCepService.getAdressbyPostalCode(postalCode).subscribe({
        next: (response: any) => {
          this.fillFormViaCep(response)
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => { },
      })
    }
  }

  getList(list: any[], type: 'contact' | 'file') {
    switch (type) {
      case 'contact':
        this.contactList = list
        break
      case 'file':
        this.fileList = list
        break
    }
  }

  createDriver() {
    const isEmployee = this.formEmployee.get('isEmployee')?.value
    const isSelfEmployed = this.formEmployee.get('isSelfEmployed')?.value
    if (!isEmployee && !isSelfEmployed && !this.supplierSelected?.id) {
      this.snackbar.error('Fornecedor é obrigatório quando o motorista não é funcionário nem autônomo.')
      return
    }
    this.loading = true
    this.driverService.createDriver(this.createModel()).subscribe({
      next: (response: ResponseRequestModel) => {
        this.loading = false
        this.snackbar.success(response.message)
        this.responseCreate.emit()
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        // this.formIndividual.reset()
        // this.formFinancial.reset()
      },
    })
  }

  openDatepicker(datePicker: 'hiring' | 'birth' | 'validity') {
    if (this.datepickerBirth && datePicker == 'birth') {
      this.datepickerBirth.open()
    }
    if (this.datepickerHiring && datePicker == 'hiring') {
      this.datepickerHiring.open()
    }
    if (this.datepickerValidity && datePicker == 'validity') {
      this.datepickerValidity.open()
    }
  }

  checkForm() {
    // Anexo (CNH digitalizada) deixou de ser obrigatório: a frota própria existe no
    // contracheque antes de existir escaneada. Dá pra anexar depois pela edição.
    if (this.formEmployee.valid && this.contactList.length >= 1) {
      return true
    } else {
      return false
    }
  }
}
